// Test IDs for the Inventario (Inventory) feature.

export const INVENTORY = {
  page: 'inventory-page',
  tabProducts: 'inventory-tab-products',
  tabPurchases: 'inventory-tab-purchases',
  tabAlerts: 'inventory-tab-alerts',
  tabMargins: 'inventory-tab-margins',
  tabReports: 'inventory-tab-reports',

  productsAddButton: 'inventory-products-add-button',
  productsShowArchivedToggle: 'inventory-products-show-archived-toggle',
  productsTable: 'inventory-products-table',
  productRowPrefix: 'inventory-product-row-', // + productId
  productLowStockBadgePrefix: 'inventory-product-low-stock-badge-',
  productEditButtonPrefix: 'inventory-product-edit-button-',
  productDeactivateButtonPrefix: 'inventory-product-deactivate-button-',
  productReactivateButtonPrefix: 'inventory-product-reactivate-button-',
  productAdjustButtonPrefix: 'inventory-product-adjust-button-',
  productsEmptyState: 'inventory-products-empty-state',

  productModal: 'inventory-product-modal',
  productModalNameInput: 'inventory-product-modal-name-input',
  productModalBrandInput: 'inventory-product-modal-brand-input',
  productModalCategorySelect: 'inventory-product-modal-category-select',
  productModalUnitInput: 'inventory-product-modal-unit-input',
  productModalCostInput: 'inventory-product-modal-cost-input',
  productModalMinStockInput: 'inventory-product-modal-min-stock-input',
  productModalStockInput: 'inventory-product-modal-stock-input',
  productModalSaveButton: 'inventory-product-modal-save-button',
  productModalCancelButton: 'inventory-product-modal-cancel-button',

  adjustModal: 'inventory-adjust-modal',
  adjustModalDeltaInput: 'inventory-adjust-modal-delta-input',
  adjustModalReasonInput: 'inventory-adjust-modal-reason-input',
  adjustModalSaveButton: 'inventory-adjust-modal-save-button',
  adjustModalCancelButton: 'inventory-adjust-modal-cancel-button',

  purchasesAddButton: 'inventory-purchases-add-button',
  purchasesList: 'inventory-purchases-list',
  purchaseItemPrefix: 'inventory-purchase-item-',
  purchasesEmptyState: 'inventory-purchases-empty-state',

  purchaseModal: 'inventory-purchase-modal',
  purchaseModalProductSelect: 'inventory-purchase-modal-product-select',
  purchaseModalQuantityInput: 'inventory-purchase-modal-quantity-input',
  purchaseModalCostInput: 'inventory-purchase-modal-cost-input',
  purchaseModalSupplierInput: 'inventory-purchase-modal-supplier-input',
  purchaseModalDateInput: 'inventory-purchase-modal-date-input',
  purchaseModalNotesInput: 'inventory-purchase-modal-notes-input',
  purchaseModalSaveButton: 'inventory-purchase-modal-save-button',
  purchaseModalCancelButton: 'inventory-purchase-modal-cancel-button',

  alertsEmptyState: 'inventory-alerts-empty-state',
  alertsList: 'inventory-alerts-list',
  alertItemPrefix: 'inventory-alert-item-',

  marginsTable: 'inventory-margins-table',
  marginRowPrefix: 'inventory-margin-row-',

  summaryValueCard: 'inventory-summary-value-card',
  summaryLowStockCard: 'inventory-summary-low-stock-card',
  summaryProductsCard: 'inventory-summary-products-card',
  reportsByProductChart: 'inventory-reports-by-product-chart',
  reportsByProfessionalChart: 'inventory-reports-by-professional-chart',
  reportsByServiceChart: 'inventory-reports-by-service-chart',
  reportsByMonthChart: 'inventory-reports-by-month-chart',
  reportsEmptyState: 'inventory-reports-empty-state',

  // Editor de receta (insumos estandar) dentro del modal de Servicio
  recipeAddButton: 'services-modal-recipe-add-button',
  recipeRowPrefix: 'services-modal-recipe-row-',
  recipeProductSelectPrefix: 'services-modal-recipe-product-select-',
  recipeQuantityInputPrefix: 'services-modal-recipe-quantity-input-',
  recipeRemoveButtonPrefix: 'services-modal-recipe-remove-button-',

  // Selector de productos consumidos dentro del modal de Tratamiento
  treatmentProductsAddButton: 'patient-treatment-modal-products-add-button',
  treatmentProductRowPrefix: 'patient-treatment-modal-product-row-',
  treatmentProductSelectPrefix: 'patient-treatment-modal-product-select-',
  treatmentProductQtyInputPrefix: 'patient-treatment-modal-product-qty-input-',
  treatmentProductRemoveButtonPrefix: 'patient-treatment-modal-product-remove-button-',
};
